import Date from './styled';

export default Date;
